export default "__VITE_ASSET__CZNkwIyF__"